var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v(_vm._s(_vm.$t("AidApplication.Title_Operation")))
    ]),
    _vm._v(" "),
    _vm.aidapplication.operation
      ? _c(
          "div",
          [
            _vm.isPlaceOpen
              ? _c("place-open-operation-view")
              : _vm.isB
              ? _c("text-area-row", {
                  attrs: {
                    title: _vm.titleForReasonsB,
                    id: "reasonsforoperationb",
                    required: true,
                    maxLength: 1500,
                    rows: 10
                  },
                  model: {
                    value: _vm.information.reasonsForOperation,
                    callback: function($$v) {
                      _vm.$set(_vm.information, "reasonsForOperation", $$v)
                    },
                    expression: "information.reasonsForOperation"
                  }
                })
              : _c(
                  "div",
                  [
                    _c("text-area-row", {
                      attrs: {
                        title: "AidApplication.Operation.ReasonsForOperation",
                        id: "reasonsforoperation",
                        required: true,
                        maxLength: 1500,
                        rows: 10
                      },
                      model: {
                        value: _vm.information.reasonsForOperation,
                        callback: function($$v) {
                          _vm.$set(_vm.information, "reasonsForOperation", $$v)
                        },
                        expression: "information.reasonsForOperation"
                      }
                    }),
                    _vm._v(" "),
                    _vm.showSimilarities
                      ? _c("similarities-control", {
                          key: _vm.checkBoxValuesChanged,
                          attrs: {
                            similarities:
                              _vm.information.similaritiesToOtherOperations
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showNonProfitDescription
                      ? _c("text-area-row", {
                          attrs: {
                            title:
                              "AidApplication.Operation.NonProfitDescription",
                            id: "nonprofitdescription",
                            required: true,
                            maxLength: 500,
                            rows: 5
                          },
                          model: {
                            value: _vm.information.nonProfitDescription,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.information,
                                "nonProfitDescription",
                                $$v
                              )
                            },
                            expression: "information.nonProfitDescription"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showCommercialActivityDescription
                      ? _c("text-area-row", {
                          attrs: {
                            title:
                              "AidApplication.Operation.CommercialActivityDescription",
                            id: "commercialactivitydescription",
                            required: true,
                            maxLength: 500,
                            rows: 5
                          },
                          model: {
                            value:
                              _vm.information.commercialActivityDescription,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.information,
                                "commercialActivityDescription",
                                $$v
                              )
                            },
                            expression:
                              "information.commercialActivityDescription"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showPublicSectorDescription
                      ? _c("text-area-row", {
                          attrs: {
                            title:
                              "AidApplication.Operation.PublicSectorDescription",
                            id: "publicsectordescription",
                            required: true,
                            maxLength: 500,
                            rows: 5
                          },
                          model: {
                            value: _vm.information.publicSectorDescription,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.information,
                                "publicSectorDescription",
                                $$v
                              )
                            },
                            expression: "information.publicSectorDescription"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.operation.targetsAndResults
                      ? _c("target-control", {
                          attrs: {
                            title:
                              "AidApplication.Operation.TargetsAndResults.Title",
                            instructionsKey:
                              "AidApplication.Operation.TargetsAndResults.Title_Instructions",
                            required: true,
                            items: _vm.operation.targetsAndResults
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("estimates-control", {
                      attrs: {
                        titleKey: "AidApplication.Operation.TargetGroup.Title",
                        tableKey: "AidApplication.Operation.TargetGroup.Select",
                        detailPlaceholderKey:
                          "AidApplication.Operation.TargetGroup.TextInput_Placeholder",
                        placeholderKey:
                          "AidApplication.Operation.TargetGroup.NumberInput_Placeholder",
                        instructionsKey:
                          "AidApplication.Operation.TargetGroup.Title_Instructions",
                        addButtonKey:
                          "AidApplication.Operation.TargetGroup.AddTargetGroup",
                        createEstimate: _vm.createTargetGroupEstimate,
                        required: true,
                        showActions: true,
                        maxRows: 10,
                        id: "target-groups"
                      },
                      model: {
                        value: _vm.targetGroupEstimates,
                        callback: function($$v) {
                          _vm.targetGroupEstimates = $$v
                        },
                        expression: "targetGroupEstimates"
                      }
                    }),
                    _vm._v(" "),
                    _c("text-area-row", {
                      attrs: {
                        title:
                          "AidApplication.Operation.MonitoringAndEvaluation",
                        id: "monitoringandevaluation",
                        required: true,
                        maxLength: 1500,
                        rows: 10
                      },
                      model: {
                        value: _vm.information.monitoringAndEvaluation,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.information,
                            "monitoringAndEvaluation",
                            $$v
                          )
                        },
                        expression: "information.monitoringAndEvaluation"
                      }
                    })
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.isExtension
              ? _c(
                  "div",
                  [
                    _c("radio-button-row", {
                      attrs: {
                        title: "AidApplication.Operation.ChangesToPreviousYear",
                        instructionsKey:
                          "AidApplication.Operation.ChangesToPreviousYear_Instructions",
                        required: true
                      },
                      model: {
                        value: _vm.information.changesToPreviousYear,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.information,
                            "changesToPreviousYear",
                            $$v
                          )
                        },
                        expression: "information.changesToPreviousYear"
                      }
                    }),
                    _vm._v(" "),
                    _vm.information.changesToPreviousYear
                      ? _c("text-area-row", {
                          attrs: {
                            title: "AidApplication.Operation.ChangeDescription",
                            id: "changedescription",
                            required: true,
                            maxLength: 1500,
                            rows: 10
                          },
                          model: {
                            value: _vm.information.changeDescription,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.information,
                                "changeDescription",
                                $$v
                              )
                            },
                            expression: "information.changeDescription"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }